export default "__VITE_ASSET__xw9xPUAP__"